import React, { useState, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { capitalize, head, startCase } from 'lodash';

import { usePersistState } from 'helper';
import List from 'partial/components/List';
import SearchBar from 'partial/components/input/SearchBar';
import EmptyState from 'partial/components/EmptyState';
import { usePlansList } from './hooks';
import Plan from './container/Plan';

function SubscriptionSettings() {
  const navigate = useNavigate();

  const [selected, setSelected] = usePersistState('plan-id', '', {
    keepOnUnmount: false,
  });
  const [filter, setFilter] = useState({
    keyword: '',
  });
  const [isLoading, data] = usePlansList(filter);

  const onSubSelect = (item) => {
    setSelected(item.uuid);
    navigate(`${item.uuid}`);
  };

  useEffect(() => {
    if (selected) return;
    setSelected(head(data)?.uuid);
  }, [data, selected, setSelected]);

  return (
    <section className="flex p-6 bg-white drop-shadow rounded-lg flex-grow static min-h-[calc(100vh_-_12rem)]">
      <div className="pr-4 border-r border-neutral-100 min-w-[260px] flex flex-col">
        <SearchBar
          name="keyword"
          value={filter.keyword}
          onChange={setFilter}
          inputClassName="py-[1.05rem] !w-full"
          containerClassName="mb-4"
        />
        <List
          data={data}
          isLoading={isLoading}
          selectedId={selected}
          onSelectRow={onSubSelect}
          render={(item) => (
            <div className="flex w- items-center gap-2 pl-2 py-[0.65rem]">
              <span className="text-xs font-light">
                {`${startCase(capitalize(item.name))} Plan`}
              </span>
            </div>
          )}
        />
      </div>
      <Routes>
        <Route path=":planId/*" element={<Plan />} />
        {data?.length > 0 && (
          <Route
            index
            element={<Navigate replace to={`${head(data)?.uuid}`} />}
          />
        )}
        <Route
          path="*"
          element={
            <div className="flex-1">
              <EmptyState
                variant="detail"
                statement="Select a plan to edit it."
              />
            </div>
          }
        />
      </Routes>
    </section>
  );
}

export default SubscriptionSettings;
